const sizeStyles = {
  xsmall: {
    width: 21,
    height: 21,
  },
  small: {
    width: 29,
    height: 29,
  },
  medium: {
    width: 40,
    height: 40,
  },
  large: {
    width: 80,
    height: 80,
  },
  xlarge: {
    width: 120,
    height: 120,
  }
}

export default sizeStyles
